a.s.itempickerelement = function () {
	var ipeobj = {};
	ipeobj.el = undefined;
	ipeobj.readonly = false;
	ipeobj.custom_template = false;
	ipeobj.custom_main_template = false;
	ipeobj.filter = {};
	ipeobj.show_unavailable = true; // Show items in use in list of selected items
	ipeobj.mark_disable_unavailable = false; // Mark items in use and disable them
	ipeobj.grouped_list = true;
	ipeobj.select_kit_as_whole = true;
	ipeobj.show_complete_kits = false;
	ipeobj.iid_list = [];
	ipeobj.checkout_id = null;
	ipeobj.change = function(){}
	ipeobj.insert = function(){
		tpl.run({tpl:'/tpl/shared/itempickerelement/' + (ipeobj.custom_main_template || 'main') + '.ejs',data:{
			readonly:ipeobj.readonly
		},cb:function(content){
			ipeobj.el.empty().append(content).ready(function(){
				ipeobj.init();
			});
		}});
	}
	ipeobj.init = function(){
		// Button
		if (!ipeobj.readonly) {
			$('button[data-action="itempickerelement_additem"]',ipeobj.el).unbind('click').click(function(){
				a.prompt.create({
					'question':'Add items',
					'answers':[{
						'value':'<i class="fa fa-list"></i>Search or select from list',
						'action':function(){
							a.s.itempicker.pick(function(itemdatalist){
								// itemdatalist.forEach(function(itemdata){
								// 	itemdata.grouped_list = ipeobj.grouped_list;
								// 	itemdata.select_kit_as_whole = ipeobj.select_kit_as_whole;
								// 	itemdata.enableIndent = true;
								// 	ipeobj.itemExist(itemdata.id,function(exist){
								// 		itemdata.disable_item = false;
								// 		if (!exist) {
								// 			tpl.run({tpl:'/tpl/shared/itempickerelement/listitem.ejs?v='+v,data:itemdata,cb:function(listitem){
								// 				$('table tbody',ipeobj.el).append(listitem).ready(function(){
								// 					ipeobj.change();
								// 				});
								// 				ipeobj.initList();
								// 			}});
								// 		}
								// 	});
								// });
								// Get new and existing IDs
								let itemDataListIds = itemdatalist.map(item => item.id);
								let inputIds = $('input[name="iid[]"]', ipeobj.el).map(function() {
									return Number($(this).val());
								}).get();
								// Merge lists
								let mergedIds = itemDataListIds.concat(inputIds);
								// Make list unique
								let uniqueIds = [...new Set(mergedIds)];
								// Update the item list
								ipeobj.updateItemList(uniqueIds);
								// Callback change
								ipeobj.change();
							},{
								multiple: true,
								grouped_list: ipeobj.grouped_list,
								select_kit_as_whole: ipeobj.select_kit_as_whole,
								filter:ipeobj.filter
							});
						}
					},{
						'value':'<i class="fa fa-qrcode"></i>Scan QR codes',
						'action':function(){
							a.s.itemqrpicker.pick(function(iid_list){
								if (iid_list.length>0) {
									var insertFilter = JSON.parse(JSON.stringify(ipeobj.filter));
									insertFilter.iid = iid_list;
									if (ipeobj.show_unavailable) {
										insertFilter.usage = [];
									}
									ipeobj.insertItems(insertFilter);
								}
								ipeobj.change();
							},{
								multiple: true,
								grouped_list: ipeobj.grouped_list,
								select_kit_as_whole: ipeobj.select_kit_as_whole,
								filter:ipeobj.filter
							});
						}
					}]
				});
			});
		}
		// Clone filter to insertFilter so it doesn't affect item picker search filters
		var insertFilter = JSON.parse(JSON.stringify(ipeobj.filter));
		// Add items if iid_list consist of items
		if (ipeobj.iid_list.length>0) {
			insertFilter.iid = ipeobj.iid_list;
			if (ipeobj.show_unavailable) {
				insertFilter.usage = [];
			}
			ipeobj.insertItems(insertFilter);
		}
	}
	ipeobj.reloadItemList = function () {
		var iid_list = $('table tbody tr[data-action="select"]',ipeobj.el).map(function() {
			return $(this).attr('data-iid');
		}).get();
		ipeobj.updateItemList(iid_list);
	}
	ipeobj.updateItemList = function (iid_list) {
		ipeobj.iid_list = iid_list;
		// Clone filter to insertFilter so it doesn't affect item picker search filters
		var insertFilter = JSON.parse(JSON.stringify(ipeobj.filter));
		// Add items if iid_list consist of items
		if (ipeobj.iid_list.length>0) {
			insertFilter.iid = ipeobj.iid_list;
			if (ipeobj.show_unavailable) {
				insertFilter.usage = [];
			}
			ipeobj.insertItems(insertFilter);
		}
	}
	
	ipeobj.insertItems = async function(filter) {
		filter.showdeleted = 1;
		filter.complete_kits = ipeobj.show_complete_kits ? 1 : 0;
		filter.ignore_kits = ipeobj.grouped_list ? 0 : 1;
		filter.checkout_id = ipeobj.checkout_id;
		filter.token = localStorage.getItem('token');
		filter.accountname = localStorage.getItem('accountname');
		var lastEnabledIndention = false;

		try {
			// Perform the AJAX request as a Promise and wait for the result
			const result = await $.ajax({
				type: 'GET',
				url: '/api/item/list_iid/',
				data: filter,
				dataType: 'json',
				cache: false
			});
	
			// Check if the result is successful and has a list of items
			if (result.success && result.list) {
				$('tr[data-type="item"]',ipeobj.el).remove();
				// Asynchronous loop over result.list
				for (const e of result.list) {
					if (lastEnabledIndention) {
						e.enableIndent = true;
					}
					else {
						e.enableIndent = false;
					}
					// Set e.enableIndent for next loop item
					if (e.is_kit || typeof(e.kit_id)=='number') {
						lastEnabledIndention = true;
					}
					else {
						lastEnabledIndention = false;
					}
					// Set other vars
					e.grouped_list = ipeobj.grouped_list;
					e.select_kit_as_whole = ipeobj.select_kit_as_whole;
	
					// Promisify ipeobj.itemExist if it's not already async
					const exist = await new Promise((resolve) => {
						ipeobj.itemExist(e.id, resolve);
					});
	
					if (ipeobj.mark_disable_unavailable && e.usage_status === 'inuse') {
						e.disable_item = true;
					} else {
						e.disable_item = false;
					}
	
					// Use ipeobj.insertItem instead of runTplAsync
					await ipeobj.insertItem(e, exist);
				}
			}
	
			// Handle after the AJAX request completes
			setTimeout(function() {
				ipeobj.change();
			}, 200);
	
		} catch (error) {
			console.error("Error fetching or processing items:", error);
		}
	};
	
	// Define the insertItem method inside ipeobj
	ipeobj.insertItem = function(e, exist) {
		return new Promise((resolve) => {
			tpl.run({
				tpl: '/tpl/shared/itempickerelement/' + (ipeobj.custom_template || 'listitem' + (ipeobj.readonly ? '_readonly' : '')) + '.ejs',
				data: e,
				cb: function(listitem) {
					if (!exist) {
						$('table tbody', ipeobj.el).append(listitem);
					} else {
						$('table tbody tr[data-iid="' + e.id + '"]', ipeobj.el).replaceWith(listitem);
					}
					$('.initial-row', ipeobj.el).remove();
					ipeobj.initList();
					resolve();  // Ensure resolve is called after the operation completes
				}
			});
		});
	};

	ipeobj.initList = function(){
		// Remove
		$('button[data-action="itempickerelement_removeitem"]',ipeobj.el).unbind('click').click(function(){
			$('tr[data-iid="'+$(this).attr('data-iid')+'"]',ipeobj.el).remove();
			if (ipeobj.grouped_list && ipeobj.select_kit_as_whole) {
				$('tr[data-parent-kit-id="'+$(this).attr('data-kit-id')+'"]',ipeobj.el).remove();
			}
			setTimeout(function(){
				ipeobj.reloadItemList();
			},100);
			ipeobj.change();
		});
		// Display checkout
		// ??? FIX
		$('[data-action="display-checkout"]').unbind('click').click(function(){
			var coid = $(this).attr('data-coid');
			require([res_path+'js/checkout.js'],
			function(){
				a.checkout.display.popup({
					cid:coid,
					close:function(){
						ipeobj.reloadItemList();
					}
				});
			});
		});
	}
	ipeobj.itemExist = function(iid,cb){
		if ($('table tr[data-iid="'+iid+'"]',ipeobj.el).length>0) {
			cb(true);
		}
		else {
			cb(false);
		}
	}
	return ipeobj;
}